<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AppNavigation from '@/components/AppNavigation.vue';
import AppLegalFooter from '@/components/AppLegalFooter.vue';

const route = useRoute();
const isWellbeingRoute = computed(() => route.path.startsWith('/wellbeing'));
</script>

<template>
  <div
    id="app"
    :class="isWellbeingRoute ? 'wellbeing-app min-h-screen' : 'min-h-screen app-with-legal-footer'"
  >
    <AppNavigation v-if="!isWellbeingRoute" />
    <main :class="isWellbeingRoute ? 'wellbeing-main' : 'app-main mx-auto max-w-7xl px-4 py-8 pb-28'">
      <router-view />
    </main>
    <AppLegalFooter v-if="!isWellbeingRoute" />
  </div>
</template>

<style>
.wellbeing-main {
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

.app-with-legal-footer {
  padding-bottom: 4rem;
}

/* Footer is hidden in mobile landscape, so stop reserving room for it. */
@media (orientation: landscape) and (max-height: 500px) {
  .app-with-legal-footer {
    padding-bottom: 0;
  }

  .app-main.pb-28 {
    padding-bottom: 1.5rem;
  }
}
</style>
